<template>
  <div class="report-view">
    <CRow>
      <CCol md="3" class="pr-0">
        <CCard>
          <CCardHeader class="pt-1 pb-1 card-title-container">
            <span class="p-card-header-title">DANH MỤC</span>
          </CCardHeader>
          <CCardBody class="pt-1 pb-1 dm-report">
            <ul>
              <li
                v-for="currentCate in listCate.filter(
                  (cate) => cate.pid === null
                )"
                :key="currentCate.id"
              >
                <span @click="toggleItem(currentCate)">{{
                  currentCate.org_name
                }}</span>
                <ul :class="{ open: currentCate.isOpen }">
                  <list-category
                    :items="getChildren(currentCate.id)"
                  ></list-category>
                </ul>
              </li>
            </ul>
            <!-- <div
              v-for="currentCate in listCate.filter(
                (cate) => cate.pid === null
              )"
              :key="currentCate.value"
            >
              <list-category
                :isOpen="true"
                :currentCate="currentCate"
                :listCate="listCate"
              ></list-category>
            </div> -->
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="9">
        <CCard class="mb-2">
          <CCardHeader class="pt-1 pb-1 card-title-container">
            <span class="p-card-header-title"
              >HIỂN THỊ CÔNG KHAI NGÂN SÁCH</span
            >
          </CCardHeader>
          <CCardBody class="pt-1 pb-1">
            <CRow class="mb-2" v-if="displayTable">
              <CCol md="6" class="info-row">
                <CInput
                  v-model="inputReportName"
                  label="Tên báo cáo"
                  placeholder="Điền tên báo cáo công khai ngân sách"
                />
              </CCol>
              <CCol md="6" class="info-row">
                <CInput
                  v-model="inputCircularsTemplateNo"
                  label="Biểu mẫu của thông tư"
                  placeholder="Điền số biểu mẫu của thông tư"
                />
              </CCol>
            </CRow>
            <CRow class="mb-2">
              <CCol md="4" class="info-row" v-if="displayTable">
                <CInput
                  v-model="inputCircularsNo"
                  label="Số thông tư áp dụng"
                  placeholder="Điền số thông tư áp dụng"
                />
              </CCol>
              <CCol :md="siteCate" class="info-row">
                <CSelect
                  :value.sync="inputCate"
                  label="Danh mục"
                  :options="listSearchCate"
                  @change="periodChange"
                />
              </CCol>
              <CCol md="4" class="info-row">
                <CInput v-model="inputReportYear" type="number" label="Năm" />
              </CCol>
            </CRow>
            <CRow class="mb-2 center">
              <div class="center">
                <vs-button
                  square
                  @click="getData"
                  class="m-auto custom_btn_search"
                  ><i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
                >
              </div>
              <div class="center" v-if="displayTable">
                <vs-button square @click="exportXml" class="m-auto"
                  ><i class="bx bxs-file-export"></i>&nbsp;Xuất XML</vs-button
                >
              </div>

              <div class="center" v-if="displayTableT2">
                <vs-button square @click="exportExcel" class="m-auto"
                  ><i class="bx bxs-file-export"></i>&nbsp;Xuất Excel</vs-button
                >
              </div>
            </CRow>
          </CCardBody>
        </CCard>
        <CCard v-if="displayTableT2">
          <CCardBody class="pt-1 pb-1">
            <!--  -->
            <CRow class="mb-12 pt-2 pb-2">
              <CCol sm="3">
                <div class="single_element">
                  <div class="single_quick_activity">
                    {{ title_one }}
                    <h3>
                      <span class="counter">{{ value_one }}</span>
                    </h3>
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="single_element">
                  <div class="single_quick_activity">
                    {{ title_two }}
                    <h3>
                      <span class="counter">{{ value_two }}</span>
                    </h3>
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="single_element">
                  <div class="single_quick_activity">
                    {{ title_three }}
                    <h3>
                      <span class="counter">{{ value_three }}</span>
                    </h3>
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="single_element">
                  <div class="single_quick_activity">
                    {{ title_four }}
                    <h3>
                      <span class="counter">{{ value_four }}</span>
                    </h3>
                  </div>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6">
                <CCard class="pb-0"
                  ><CCardHeader class="text-center pt-0 pb-0">
                    <span class="card-header-title">{{ label_one }}</span>
                  </CCardHeader>
                  <b-overlay
                    :show="!statedashboard.loading_one"
                    no-wrap
                    spinner-variant="success"
                    spinner-type="grow"
                    rounded="sm"
                    opacity="0.8"
                    z-index="1000"/>
                  <CChartLine
                    style="height:300px"
                    :datasets="data_one"
                    :labels="label_year_one"
                    :options="lineChartOptions"/></CCard
              ></CCol>

              <CCol sm="6">
                <CCard class="pb-0"
                  ><CCardHeader class="text-center pt-0 pb-0">
                    <span class="card-header-title">{{ label_two }}</span>
                  </CCardHeader>
                  <b-overlay
                    :show="!statedashboard.loading_two"
                    no-wrap
                    spinner-variant="success"
                    spinner-type="grow"
                    rounded="sm"
                    opacity="0.8"
                    z-index="1000"
                  />

                  <CChartLine
                    style="height:300px"
                    :datasets="data_two"
                    :labels="label_year_two"
                    :options="lineChartOptions"
                  /> </CCard
              ></CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CCard v-if="displayTable" style="overflow-x: scroll;">
          <vue-good-table
            :columns="columns"
            :rows="tableData"
            compactMode
            styleClass="vgt-table bordered striped"
            :pagination-options="{
              enabled: true,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
            }"
            :sort-options="{
              enabled: false,
            }"
            :line-numbers="true"
          >
            <div
              slot="emptystate"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              Không có dữ liệu công khai ngân sách
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field === 'status'">
                <span v-if="props.row.status === 0" class="badge badge-danger">
                  Không sử dụng
                </span>
                <span
                  v-else-if="props.row.status === 1"
                  class="badge badge-primary"
                >
                  Sử dụng
                </span>
                <span v-if="props.row.status === 2" class="badge badge-success">
                  Công khai
                </span>
              </div>
              <div
                v-else-if="props.column.field === 'file_link'"
                class="center"
              >
                <vs-tooltip color="square">
                  <vs-button
                    transparent
                    @click="displayFile(props.row.list_file)"
                    :hidden="props.row.list_file.length <= 0"
                    square
                    circle
                    icon
                    ><i class="bx bxs-file"></i
                  ></vs-button>
                  <template #tooltip>
                    Xem file đính kèm
                  </template>
                </vs-tooltip>
              </div>
            </template>
          </vue-good-table>
        </CCard>
        <CCard v-if="displayTableT2" style="overflow-x: scroll;">
          <vuetable :fields="columnsT2" :css="csstableT2" :data="tableDataT2"
            ><template slot="tableHeader">
              <template>
                <tr>
                  <th
                    v-for="header in headerRows"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid;  border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>
                <tr>
                  <th
                    v-for="header in headerRowsTwo"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid; border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>

                <tr>
                  <th
                    v-for="header in headerRowsThree"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid; border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>
              </template>
              <vuetable-row-header></vuetable-row-header> </template
          ></vuetable>
        </CCard>
      </CCol>
    </CRow>

    <!-- show list file -->
    <vs-dialog prevent-close square width="650px" v-model="state.dialog.files">
      <ListFile :file_data="this.file_data" />
    </vs-dialog>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import ListFile from "../../components/files/ListFile";
const api = ClientFactory.get("publicbudgetreport");
const apiDF = ClientFactory.get("databasefinance");
const exportApi = ClientFactory.get("budgetreport");
import listCategory from "@/components/budgetreport/ListCategoryV2";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";
import Vuetable from "vuetable-2/src/components/Vuetable.vue";
import { CChartLine } from "@coreui/vue-chartjs";

export default {
  components: {
    VueGoodTable,
    listCategory,
    ListFile,
    VuetableRowHeader,
    Vuetable,
    CChartLine,
  },
  data() {
    return {
      displayTable: true,
      displayTableT2: false,
      siteCate: 4,
      inputReportYear: new Date().getFullYear(),
      inputReportName: "",
      inputCircularsTemplateNo: "",
      inputCircularsNo: "",
      inputCate: "",
      listSearchCate: [
        {
          value: -1,
          label: "Tất cả",
        },
      ],
      listSearchCateCK: [],
      listCate: [],
      listCateQT: [],
      listCateTS: [],
      listCateTemp: [],
      columns: [
        {
          label: "Tên báo cáo",
          field: "report_name",
          thClass: "text-center",
        },
        {
          label: "Năm báo cáo",
          type: "number",
          field: "report_year",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Biểu mẫu",
          field: "circulars_template_no",
          thClass: "text-center",
          tdClass: "text-center",
          width: "90px",
        },
        {
          label: "Số quyết định/VB Công bố",
          field: "document_no",
          thClass: "text-center",
        },
        {
          label: "Ngày công bố",
          field: "publish_date",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Đường dẫn toàn văn",
          field: "file_link",
          thClass: "text-center",
          width: "90px",
        },
      ],
      tableData: [],
      file_data: [],
      state: {
        dialog: {
          files: false,
        },
      },

      headerRows: [],
      headerRowsTwo: [],
      headerRowsThree: [],
      columnsT2: [],
      tableDataT2: [],
      csstableT2: {
        tableWrapper: "",
        tableHeaderClass: "",
        tableBodyClass: "mb-0",
        tableClass: "table ui celled padded",
        loadingClass: "loading",
        detailRowClass: "vuetable-detail-row",
        handleIcon: "fa fa-bars text-secondary",
      },

      /////
      statedashboard: {
        loading_one: false,
        loading_two: false,
      },
      label_year_two: [],
      label_year_one: [],

      label_two: "",
      label_one: "",

      data_one: [],
      data_two: [],
      title_one: "Số 1",
      value_one: "231321",
      title_two: "số 2",
      value_two: "231321",
      title_three: "số 3",
      value_three: "231321",
      title_four: "số 4",
      value_four: "231321",
    };
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async getData() {
      this.loading(this.$vs);
      // Chỉ filter các báo cáo ở trạng thái công khai: Trạng thái: 0 - không sử dụng, 1 - sử dụng, 2 - công khai

      if (!isNaN(this.inputCate)) {
        this.displayTable = true;
        this.displayTableT2 = false;
        this.tableData = (
          await api.searchPublicReport(
            this.inputReportName,
            this.inputCircularsTemplateNo,
            this.inputCircularsNo,
            this.inputCate,
            "",
            2,
            "",
            "",
            this.inputReportYear,
            -1,
            -1
          )
        ).data;
      } else {
        this.displayTable = false;
        this.displayTableT2 = true;
        if (
          this.inputCate == "10A" ||
          this.inputCate == "10B" ||
          this.inputCate == "10C" ||
          this.inputCate == "10D"
        ) {
          const { data } = await apiDF.PUB_searchAsset(
            this.inputReportYear,
            this.inputCate
          );

          if (data.status == "success") {
            if (data.data) {
              this.tableDataT2 = data.data[0].data;
              this.headerRows = data.data[0].headerRows;
              this.headerRowsTwo = data.data[0].headerRowsTwo;
              this.headerRowsThree = data.data[0].headerRowsThree;
              this.columnsT2 = data.data[0].columns;
            } else this.tableData = [];
          } else {
            if (data.message != "Xin lỗi, không có dữ liệu") {
              this.notify({
                error: true,
                title: "Thông báo",
                text: data.message,
              });
            }
          }
        } else {
          this.getDashboards();
          const { data } = await apiDF.PUB_searchSettlement(
            this.inputReportYear,
            this.inputCate
          );

          if (data.status == "success") {
            if (data.data) {
              this.tableDataT2 = data.data[0].data;
              this.headerRows = data.data[0].headerRows;
              this.headerRowsTwo = data.data[0].headerRowsTwo;
              this.headerRowsThree = data.data[0].headerRowsThree;
              this.columnsT2 = data.data[0].columns;
            } else this.tableData = [];
          } else {
            if (data.message != "Xin lỗi, không có dữ liệu") {
              this.notify({
                error: true,
                title: "Thông báo",
                text: data.message,
              });
            }
          }
        }
      }
      this.closeLoading();
    },

    async periodChange() {
      if (!isNaN(this.inputCate)) this.inputReportYear = 2023;
      else this.inputReportYear = await apiDF.getYear(this.inputCate);
      this.getData();
    },
    displayFile(files) {
      //console.log(files);
      let arrFile = files.split("||");
      let data = [];

      for (let index = 0; index < arrFile.length; index++) {
        let file = arrFile[index];
        data[index] = {
          file_name: file.split("|")[0],
          file_url: file.split("|")[1],
        };
      }
      this.file_data = data;
      //show dialog
      this.state.dialog.files = true;
    },
    async exportXml() {
      this.loading(this.$vs);
      const filter = {
        report_name: this.inputReportName,
        circulars_template_no: this.inputCircularsTemplateNo,
        circulars_no: this.inputCircularsNo,
        cate_id: this.inputCate,
        report_year: this.inputReportYear,
        status: 2, // Trạng thái: 0 - không sử dụng, 1 - sử dụng, 2 - công khai
      };
      await exportApi.getXml(filter);
      this.closeLoading();
    },
    async exportExcel() {
      this.loading(this.$vs);

      if (
        this.inputCate == "10A" ||
        this.inputCate == "10B" ||
        this.inputCate == "10C" ||
        this.inputCate == "10D"
      ) {
        const filter2 = {
          reportCode: this.inputCate,
          // maDonVi: "T55",
          maKy: "NAM",
          nam: this.inputReportYear,
        };
        await apiDF.getFileTS(filter2);
      } else {
        const filter = {
          reportCode: this.inputCate,
          maDonVi: "T55",
          maKyBC: "NAM",
          namBC: this.inputReportYear,
        };
        await apiDF.getFileQT(filter);
      }

      this.closeLoading();
    },
    async toggleItem(item) {
      if (item.id == "1")
        window.open(
          "https://dichvucong.thainguyen.gov.vn/recordtype/000.00.17.H55",
          "_blank"
        );
      else if (item.id == "QT") {
        this.siteCate = 8;
        this.listSearchCate = this.listCateQT;
        this.inputCate = "BM28-CK-NSNN";
        if (!isNaN(this.inputCate)) this.inputReportYear = 2023;
        else this.inputReportYear = await apiDF.getYear(this.inputCate);
        this.getData();
      } else if (item.id == "TS") {
        this.siteCate = 8;
        this.listSearchCate = this.listCateTS;
        this.inputCate = "10A";
        if (!isNaN(this.inputCate)) this.inputReportYear = 2023;
        else this.inputReportYear = await apiDF.getYear(this.inputCate);
        this.getData();
      } else {
        this.siteCate = 4;
        this.displayTable = true;
        this.displayTableT2 = false;
        this.listSearchCate = this.listSearchCateCK;
        item.isOpen = !item.isOpen;
      }
    },
    getChildren(parentID) {
      return this.listCate.filter((item) => item.pid === parentID);
    },

    getDashboards: async function() {
      this.state.loading_revenue = false;
      const dataDS = await apiDF.getDashboard(
        this.inputCate,
        this.inputReportYear
      );
      if (dataDS.data.length > 0) {
        console.log(dataDS.data[0]);
        this.title_one = dataDS.data[0].title_one;
        this.value_one = dataDS.data[0].value_one;

        this.title_two = dataDS.data[0].title_two;
        this.value_two = dataDS.data[0].value_two;

        this.title_three = dataDS.data[0].title_three;
        this.value_three = dataDS.data[0].value_three;

        this.title_four = dataDS.data[0].title_four;
        this.value_four = dataDS.data[0].value_four;

        this.label_year_one = dataDS.data[0].label_year_one;
        this.label_year_two = dataDS.data[0].label_year_two;
        this.label_one = dataDS.data[0].label_one;
        this.label_two = dataDS.data[0].label_two;
        let jsonSendDocuments = dataDS.data[0].jsonSendDocuments_one;
        this.statedashboard.loading_one = true;
        this.data_one = jsonSendDocuments;

        //////// char 2
        jsonSendDocuments = dataDS.data[0].jsonSendDocuments_two;
        this.statedashboard.loading_two = true;
        this.data_two = jsonSendDocuments;
      }
    },
  },
  async created() {
    if (this.$route.query.cateId != undefined) {
      this.inputCate = this.$route.query.cateId;
    }
    this.loading(this.$vs);

    this.listCateTemp = await api.getItemsTree();
    // console.log(this.listCateTemp);
    this.listCate.push({
      id: 1,
      label: "THỦ TỤC HÀNH CHÍNH",
      level: 1,
      org_name: "THỦ TỤC HÀNH CHÍNH",
      pid: null,
      value: "1",
      isOpen: true,
    });
    for (var i = 0; i < this.listCateTemp.length; i++) {
      this.listSearchCate.push(this.listCateTemp[i]);
      this.listCate.push(this.listCateTemp[i]);
    }

    this.listCateTemp = [];

    let stt = 10;
    this.listCateQT.push({
      id: "QT",
      label: "DỮ LIỆU CK QUYẾT TOÁN NGÂN SÁCH NHÀ NƯỚC",
      level: 1,
      org_name: "DỮ LIỆU CK QUYẾT TOÁN NGÂN SÁCH NHÀ NƯỚC",
      pid: null,
      value: "BCQT",
    });

    this.listCate.push({
      id: "QT",
      label: "DỮ LIỆU CK QUYẾT TOÁN NGÂN SÁCH NHÀ NƯỚC",
      level: 1,
      org_name: "DỮ LIỆU CK QUYẾT TOÁN NGÂN SÁCH NHÀ NƯỚC",
      pid: null,
      value: "BCQT",
    });
    this.listCateTemp = await apiDF.getqt();

    for (i = 0; i < this.listCateTemp.length; i++) {
      this.listCateQT.push({
        id: stt + i,
        label: "--" + this.listCateTemp[i].label,
        level: 2,
        org_name: "--" + this.listCateTemp[i].label,
        pid: "QT",
        value: this.listCateTemp[i].value,
      });
      // this.listCate.push({
      //   id: stt + i,
      //   label: this.listCateTemp[i].label,
      //   level: 2,
      //   org_name: this.listCateTemp[i].label,
      //   pid: stt,
      //   value: this.listCateTemp[i].value,
      // });
    }
    stt = 20;
    this.listCateTS.push({
      id: "TS",
      label: "DỮ LIỆU CK TÀI SẢN CÔNG",
      level: 1,
      org_name: "DỮ LIỆU CK TÀI SẢN CÔNG",
      pid: null,
      value: "BCTS",
    });

    this.listCate.push({
      id: "TS",
      label: "DỮ LIỆU CK TÀI SẢN CÔNG",
      level: 1,
      org_name: "DỮ LIỆU CK TÀI SẢN CÔNG",
      pid: null,
      value: "BCTS",
      isOpen: false,
    });
    this.listCateTemp = await apiDF.getts();
    for (i = 0; i < this.listCateTemp.length; i++) {
      this.listCateTS.push({
        id: stt + i,
        label: "--" + this.listCateTemp[i].label,
        level: 2,
        org_name: "--" + this.listCateTemp[i].label,
        pid: "TS",
        value: this.listCateTemp[i].value,
      });
      // this.listCate.push({
      //   id: stt + i,
      //   label: this.listCateTemp[i].label,
      //   level: 2,
      //   org_name: this.listCateTemp[i].label,
      //   pid: stt,
      //   value: this.listCateTemp[i].value,
      // });
    }
    this.listCateTemp = this.listCate;
    this.listCate = [];

    const newElement = {
      // Thuộc tính và giá trị mới
      isOpen: false,
    };

    // Thêm đối tượng newElement vào mảng this.list tại vị trí i

    for (i = 0; i < this.listCateTemp.length; i++) {
      this.listCateTemp[i] = { ...this.listCateTemp[i], ...newElement };
      this.listCate.push(this.listCateTemp[i]);
    }

    this.listSearchCateCK = this.listSearchCate;
    this.closeLoading();
    await this.getData();
  },
  mounted() {
    this.$root.$on("ReportViewerChangeCategory", (cateId) => {
      if (cateId == "1")
        window.open(
          "https://dichvucong.thainguyen.gov.vn/recordtype/000.00.17.H55",
          "_blank"
        );
      else {
        if (cateId == "QT") {
          // console.log(this.listCateQT);
          this.listSearchCate = this.listCateQT;
          this.inputCate = "BM28-CK-NSNN";
        } else if (cateId == "TS") {
          this.listSearchCate = this.listCateTS;
          this.inputCate = "10A";
        } else {
          this.listSearchCate = this.listSearchCateCK;
          this.inputCate = cateId;
        }

        if (!isNaN(this.inputCate)) this.inputReportYear = 2023;
        else this.inputReportYear = 2021;
        this.getData();
      }
    });
  },
  computed: {
    data_label_nam() {
      return [
        new Date().getFullYear() - 4,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 1,
        // new Date().getFullYear(),
      ];
    },
    lineChartOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          xAxes: [
            {
              display: true,
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  if (parseInt(value) >= 1000) {
                    return value
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  } else {
                    return value;
                  }
                },
              },
            },
          ],
        },
        elements: {
          line: {
            borderWidth: 2,
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              return ` ${
                data.datasets[tooltipItem.datasetIndex].label[0]
              }: ${tooltipItem.yLabel
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} triệu đồng`;
            },
          },
        },
      };
    },
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<style lang="scss">
.report-view {
  table.vgt-table td {
    vertical-align: inherit;
    color: black !important;
    font-size: 14px;
    //padding: 0.3rem !important;
    padding: 0em 0.75em 0em 0.75em;
  }

  table.vgt-table th {
    font-size: 14px;
  }
  .vgt-responsive {
    overflow-x: inherit;
  }
  label {
    color: black;
  }
  .card-title-container {
    background: #082258;
  }
  .card-title-container h4 {
    color: white;
  }

  .info-row {
    margin-top: 7px;
  }
  .p-card-header-title {
    font-size: 1.2125rem;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    color: white;
  }

  .tbl-disible {
    display: none;
  }
  .table-right {
    text-align: right;
  }
  .table-left {
    text-align: left;
    border-right: 1px solid;
    border-right-color: #d8dbe0;
  }

  .table-center {
    text-align: center;
    border-right: 1px solid;
    border-right-color: #d8dbe0;
  }
  .table-bold {
    font-weight: bold;
  }

  .dm-report ul,
  .dm-report li,
  .dm-report ol {
    margin: 0px;
    padding: 0px;
    list-style: none;
    font-size: 14px;
  }

  .dm-report ul li ul {
    position: relative;
    display: none;
  }
  .dm-report ul li ul.open {
    display: block;
  }
  .dm-report ul li ul:before {
    top: 10px;
    position: absolute;
    content: "";
    left: 0px;
    width: 1px;
    border-left: 1px solid #082258;
    bottom: 0px;
  }

  .dm-report ul:before {
    top: 10px;
    position: absolute;
    content: "";
    left: 20px;
    width: 1px;
    border-left: 1px solid #082258;
    bottom: 0px;
  }

  .dm-report ul > li {
    line-height: 20px;
  }

  .dm-report ul > li > span {
    text-transform: uppercase;
    color: #082258;
    font-weight: bold;
    margin-bottom: 5px;
    display: block;
    position: relative;
    padding-left: 30px;
  }

  .dm-report ul > li > ul > div > li {
    line-height: 30px;
  }

  .dm-report ul > li > ul > div > li > span {
    text-transform: uppercase;
    color: #082258;
    margin-bottom: 5px;
    display: block;
    position: relative;
    padding-left: 40px;
  }

  .dm-report ul > li > span:before {
    content: "";
    position: absolute;
    left: 0px;
    width: 20px;
    height: 2px;
    top: 0px;
    margin: auto;
    bottom: 0px;
    border-bottom: 1px solid #082258;
  }

  .dm-report ul > li > ul > div > li > span:before {
    content: "";
    position: absolute;
    left: 0px;
    width: 20px;
    height: 2px;
    top: 0px;
    margin: auto;
    bottom: 0px;
    border-bottom: 1px solid #082258;
  }

  .dm-report ul > li > span:after {
    width: 5px;
    height: 5px;
    background: #082258;
    position: absolute;
    content: "";
    top: 0px;
    left: 20px;
    bottom: 0px;
    margin: auto;
  }

  .dm-report ul > li > ul > div > li > span:after {
    width: 5px;
    height: 5px;
    background: #082258;
    position: absolute;
    content: "";
    top: 0px;
    left: 20px;
    bottom: 0px;
    margin: auto;
  }

  .dm-report ul ul > li > span:after {
    background: #b9b9b9;
    display: block;
    left: 2px;
  }

  .dm-report ul ul > li > span:before {
    content: "";
    position: absolute;
    left: -20px;
    width: 20px;
    height: 2px;
    top: 0px;
    margin: auto;
    bottom: 0px;
    border-bottom: 1px dotted #343434;
  }

  .dm-report ul ul > li > span:before {
    content: "";
    position: absolute;
    left: -20px;
    width: 20px;
    height: 2px;
    top: 0px;
    margin: auto;
    bottom: 0px;
    border-bottom: 1px dotted #343434;
  }

  .dm-report ul li ul:before {
    position: absolute;
    width: 2px;
    border-left: 1px dotted #343434;
    content: "";
    left: 0px;
    top: 0px;
    bottom: 0px;
  }

  .dm-report ul ul > li {
    position: relative;
    padding-left: 20px;
  }

  .dm-report ul ul > li > span {
    color: #343434;
    display: block;
    text-transform: none;
    position: relative;
    font-weight: normal;
    padding-left: 15px;
    font-size: 14px;
  }

  .table-width {
    min-width: 200px;
  }
  .table-width-10 {
    min-width: 100px;
  }
  .single_element {
    border-radius: 10px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    padding: 41px 30px;
    position: relative;
    background: #e0ebff;
    min-height: 200px;
  }
  .quick_activity_wrap {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 30px;
    margin-bottom: 50px;
  }
}
</style>
